import { gql } from "@apollo/client";

export const CHECK_FOR_SETUP = gql`
  query getUserForSetup($id: String!) {
    users_by_pk(id: $id) {
      id
      name
      upline
      username
      country
    }
    country {
      id
      name
    }
  }
`;
